
module.exports = {
	methods: {
		getLoadAction: function(route){
			// check if route is a routeID
			var isRouteID = false;
			if(route == parseInt(route)) {
				isRouteID = true;
			}

			if(isRouteID){
				return this.exportAction('loadRouteID', {
					source: {
						load: {
							builtRouteID: route
						}
					}
				});
			}
			else {
				return this.exportAction('loadRoute', {
					source: {
						load: {
							builtRoute: route
						}
					}
				});
			}
		}
	}
};